import { Box, Button, Typography } from "@mui/material";
import React from "react";

const TextSection1 = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        backgroundImage: `url('bg3.svg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        py: { xs: 6, md: 10 },
      }}
    >
      <Box
        sx={{
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            border: { xs: "none", md: "1px solid #ccc" },
            borderRadius: "10px",
            boxShadow: { xs: "none", md: "0px 10px 15px rgb(0, 0, 0, 0.1)" },
            backgroundColor: { xs: "transparent", md: "rgb(255,255,255, 0.1)" },
            backdropFilter: { xs: "blur(0)", md: "blur(10px)" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            py: 4,
            px: { xs: 0, md: 4 },
            width: "80%",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "2.3rem", md: "2.8rem" },
              textAlign: "center",
              background: "",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            Yes, it's that easy!
          </Typography>
          <Typography
            color="text.secondary"
            sx={{
              fontSize: { xs: "18px", md: "20px" },
              textAlign: "center",
              color: "rgba(255, 255, 255, 0.66)",
              py: 2,
              px: 4,
            }}
          >
            Unlock the Flow Builder in the Vertex Suite app now and start
            selling your products on WhatsApp instantly.
          </Typography>
          <Box
            sx={{
              height: { xs: "100%", md: "40vh" },
              width: "100%",
            }}
          >
            <img
              src="https://cdn.prod.website-files.com/62038ffc9cd2db6132e3c782/6765643144bd9647a8bc72a6_wf-m-mini.svg"
              alt="img"
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </Box>
          <Button
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#28568f",
              color: "white",
              fontWeight: "bold",
              px: 3,
              py: 1.2,
              borderRadius: "8px",
              transition: "all 0.3s ease",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            UNLOCK FLOW BUILDER →
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TextSection1;
